import { CUSTOM_CALCULATION_DATA_FIELD_KEY_PREFIX } from '../../../../shared/constants/dataFieldKeys';
import type { ErrorSpec } from '../types/analyticsConstantsTypes';

export const DATA_LIMIT_MESSAGE =
  "We couldn't load all of your data due to your volume for this set of filters and compares.";

export const GENERIC_ERROR_TYPE = 'generic';
export const WHITELISTED_ERROR_TYPE = 'whitelisted';

export const ERROR_WHITELIST: ErrorSpec[] = [
  {
    shortErrorMessage: 'Your analytics request spans our upgrade uniques cutoff date.',
    regex: /Your analytics request spans our upgrade uniques cutoff date\./,
  },
  {
    shortErrorMessage: 'Error Requesting Analytics Data',
    regex: /Please remove your (.+) filter(s?) or reduce the total time range you are querying to 90 days\./,
  },
  {
    shortErrorMessage: 'A selected custom calculation contains events or metrics not available. Remove it and try again',
    regex: /^Custom calculation (.+) contains events or metrics not available in (.+)$/,
    buildErrorMessage: (message) => `${message}. Remove it and try again`,
  },
  {
    shortErrorMessage: 'Requested custom calculation(s) cannot be found or accessed. Remove them and try again',
    regex: /^Requested custom calculations cannot be found or accessed: \[(.+)\]/,
    buildErrorMessage: (message, metadata = {}) => {
      if (!Array.isArray(metadata.selectedColumns) || !metadata.selectedColumns.length) {
        return;
      }
      const calculationIds = JSON.parse(message.split(': ')[1]);
      const unavailableCalculationColumns = calculationIds.map((id) =>
        metadata.selectedColumns.find((column) => column.key === `${CUSTOM_CALCULATION_DATA_FIELD_KEY_PREFIX}${id}`)
      );
      const calculationNames = unavailableCalculationColumns.map((column) => `"${column.display}"`).join(', ');
      return `Requested custom calculations ${calculationNames} cannot be found or accessed. Remove them and try again`;
    },
  },
  {
    shortErrorMessage: 'Exceeded maximum number of custom calculations. Remove some and try again',
    regex: /^A maximum of \d+ custom calculations can be requested on an analytics query. \d+ were provided$/,
    buildErrorMessage: (message) => message,
  },
  {
    shortErrorMessage:
      'The server is currently unavailable - it is overloaded or down for maintenance. Please wait a few minutes and try again.',
    regex: /Service unavailable/,
  },
];

export const GROUP_BY_QUERY_TYPE = 'groupby';
